import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injectable, Injector } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { Data } from './DataService';
import { RoutingService } from './routing-service';
import { RefreshSidebarService } from './refreshSidebar.service';
import { HttpResponseInceptor } from './http.interceptor';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { PopupModule } from './popup/popup.module';
import { LoginComponent } from './login/login.component';
import { SlickCarouselComponent, SlickCarouselModule } from 'ngx-slick-carousel';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Device } from '@ionic-native/device/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { TouchID } from '@ionic-native/touch-id/ngx';
import { Platform } from '@ionic/angular';
import { AndroidFingerprintAuth } from '@ionic-native/android-fingerprint-auth/ngx';
import { VideoCapturePlus } from '@ionic-native/video-capture-plus/ngx';

import { initializer } from './app.init';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { ToastrModule } from 'ngx-toastr';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { Contacts } from '@ionic-native/contacts';
import { CameraPreview } from '@awesome-cordova-plugins/camera-preview/ngx';
import { MobileService } from './mobile.services';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { Dialogs } from '@ionic-native/dialogs/ngx';
import { SessionTimeoutPageComponent } from './session-timeout-page/session-timeout-page.component';
import { HTTP } from '@ionic-native/http/ngx';
import { NgOtpInputModule } from 'ng-otp-input';

import { MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import * as Hammer from "hammerjs";
import { FCMPluginOnIonic } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/FCM';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PopupContentComponent } from './popup-content/popup-content.component';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { AuthGuardService } from './auth-guard.service';
import { AuthService } from './auth.service';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppInitService } from './services/app-init.service';


import { FormControlTemplatesComponent } from './templates/form-control-templates/form-control-templates.component';
import { FormControlTemplatesDirective } from './templates/form-control-templates.directive';
import { IsRowSelectedPipe } from './templates/is-row-selected.pipe';
import { CommonModule } from '@angular/common';
import { FormDropdownTemplatesComponent } from './templates/form-dropdown-templates/form-dropdown-templates.component';
import { FormCardsTemplatesComponent } from './templates/form-cards-templates/form-cards-templates.component';
import { FormRoGridTemplatesComponent } from './templates/form-ro-grid-templates/form-ro-grid-templates.component';
import { ResponsiveService } from './responsive.service';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { FpxCoreModule } from './fpx-core';
import { MicrositeGuard } from './guard/microsite.guard';


@Injectable()
export class AppHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { enable: true, direction: Hammer.DIRECTION_ALL },
    pan: { enable: true, direction: Hammer.DIRECTION_ALL },
    pinch: { enable: false },
    rotate: { enable: false },
  };
}

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "launcher",
    pathMatch: "full",
  },
  {
    path: "launcher",
    component: SplashScreenComponent
  },
  {
    path: "login",
    loadChildren: () => import('./pre-login-home/pre-login-home.module').then(m => m.PreLoginHomeModule),
    canActivate: [MicrositeGuard]
  },
  {
    path: "rm-home",
    loadChildren: () => import('src/app/rm/rm-home/rm-home.module').then(m => m.RmHomeModule),
    canActivate: [MicrositeGuard]
  },
  // {
  //   path: "login",
  //   loadChildren: () => import('./Prelogin/Prelogin.module').then(m => m.PreloginModule)
  // },

  {
    path: "process-shell",
    loadChildren: () => import('./process-shell/process-shell.module').then(m => m.ProcessShellModule),
  },
  

  {
    path: "onboarding",
    loadChildren: () => import('./on-boarding/on-boarding.module').then(m => m.OnBoardingModule)
  },

  {
    path: "SessionTimedOut",
    component: SessionTimeoutPageComponent,
  },

  {
    path: "default-shell",
    loadChildren: () => import('src/app/shell/shell.module').then(m => m.ShellModule)
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    SessionTimeoutPageComponent,
    LoginComponent,
    FormControlTemplatesComponent,
    FormControlTemplatesDirective,
    IsRowSelectedPipe,
    FormDropdownTemplatesComponent,
    FormCardsTemplatesComponent,
    FormRoGridTemplatesComponent,
    SplashScreenComponent
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    RouterModule
  ],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, { useHash: true, relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload' }),
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserModule,
    MatChipsModule,
    NgbModalModule,
    MatButtonModule,
    MatRadioModule,
    //Ng4LoadingSpinnerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    PopupModule,
    SlickCarouselModule,
    ImageCropperModule,
    KeycloakAngularModule,
    ToastrModule.forRoot(),
    NgOtpInputModule,
    NgCircleProgressModule.forRoot({}),
    NgxSkeletonLoaderModule,
    HammerModule,
    NgSelectModule,
    CommonModule,
    FpxCoreModule
  ],
  providers: [
    Data,
    FCMPluginOnIonic,
    RoutingService,
    RefreshSidebarService,
    MobileService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initializer, multi: true, deps: [MobileService, AppInitService, ResponsiveService] },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: AppHammerConfig,
    },
    DeviceDetectorService,
    Device,
    TouchID,
    Platform,
    AndroidFingerprintAuth,
    Camera,
    SocialSharing,
    FileTransfer,
    FileTransferObject,
    File,
    Contacts,
    CameraPreview,
    NativeStorage,
    Diagnostic,
    Dialogs,
    HTTP,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    AuthGuardService,
    AuthService,
    AppVersion,
    FileOpener,
    VideoCapturePlus
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private injector: Injector) { }

  ngDoBootstrap() {
    
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
